<shared-most-famous-assets [instruments]="facade.mostPopularEtfs$ | async" [type]="type" />
